var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { AvailableStaffStatus } from "./AvailableStaffState";
import { AVAILABLE_STAFF_RESET_ACTION_TYPE, AVAILABLE_STAFF_FETCH_START_ACTION_TYPE, AVAILABLE_STAFF_FETCH_SUCCESS_ACTION_TYPE, AVAILABLE_STAFF_ERROR_ACTION_TYPE, AVAILABLE_STAFF_UNAVAILABLE_START_ACTION_TYPE, AVAILABLE_STAFF_UNAVAILABLE_SUCCESS_ACTION_TYPE, } from "../action/AvailableStaffActionsTypes";
var initialState = {
    availableStaffForAppointment: new Map(),
    unavailableStaff: [],
    status: AvailableStaffStatus.Initial,
    lastRequest: {
        unavailable: '',
    }
};
export var availableStaffReducer = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case AVAILABLE_STAFF_RESET_ACTION_TYPE:
            return __assign({}, initialState);
        case AVAILABLE_STAFF_FETCH_START_ACTION_TYPE:
            var startMap = new Map(state.availableStaffForAppointment);
            startMap.delete(action.payload.appointmentId);
            return __assign(__assign({}, state), { status: AvailableStaffStatus.Fetching, availableStaffForAppointment: startMap });
        case AVAILABLE_STAFF_FETCH_SUCCESS_ACTION_TYPE:
            var successMap = new Map(state.availableStaffForAppointment);
            successMap.set(action.payload.appointmentId, action.payload.availableStaff);
            return __assign(__assign({}, state), { status: AvailableStaffStatus.FetchSuccess, availableStaffForAppointment: successMap });
        case AVAILABLE_STAFF_UNAVAILABLE_START_ACTION_TYPE:
            return __assign(__assign({}, state), { status: AvailableStaffStatus.FetchingUnavailable, lastRequest: __assign(__assign({}, state.lastRequest), { unavailable: action.payload.requestToken }) });
        case AVAILABLE_STAFF_UNAVAILABLE_SUCCESS_ACTION_TYPE:
            return __assign(__assign({}, state), { status: AvailableStaffStatus.FetchUnavailableSuccess, unavailableStaff: action.payload.staff });
        case AVAILABLE_STAFF_ERROR_ACTION_TYPE:
            return __assign(__assign({}, state), { status: AvailableStaffStatus.Error, availableStaffForAppointment: new Map() });
        default:
            return state;
    }
};
export default availableStaffReducer;
